export default {
  login_register: 'Kirjaudu / rekisteröidy',
  booking_confirmation_title: 'Varausvahvistus',
  booking_confirmation_body: 'Kiitos varauksestasi. Alta näet varaustietosi.',
  insurance_requirements_modal_disclaimer: `Tekemällä tämän varauksen vakuutan seuraavan: Minulla ei ole ollut tuomioita tai moottoririkoksia viimeisen 5 vuoden aikana. Minulla ei ole ollut ehdotusta hylättyä, peruutettua vakuutusta tai uusimista kieltäytynyt tai sitä ei ollut vaadittu maksamaan korotettua vakuutusmaksua tai minkään moottoriajoneuvovakuuttajan asettamia erityisehtoja. Minua ei ole ajettu ajokieltoon. Minulla ei ole vireillä syytteitä tai poliiseja. Minulla ei ole tuomioita varkauksiin, petoksiin tai epärehellisyyteen liittyvistä rikoksista viimeisen viiden vuoden aikana. Minulla ei ole kärsinyt näkö- tai kuulovaurioista (joita ei ole korjattu silmälaseilla tai kuulolaitteilla), sydänsairauksista, diabeetikosta, aivohalvauksista tai minkäänlaisesta fyysisestä tai henkisestä vammasta. Minulla ei ole ollut tapaturmia viimeisen 5 vuoden aikana.`,
  insurance_requirements_here: '',
  insurance_requirements: "Olen lukenut ja ymmärtänyt {0}",
  ir: 'Täytän vakuutusvaatimukset',
  location: 'Sijainti',
  pickup_location: 'Noutopaikka',
  dropoff_location: 'Palautuspaikka',
  vehicle: 'Ajoneuvo',
  pickup_and_dropoff: 'Nouto ja palautus (paikallista aikaa)',
  distance_allowance: 'Sallittu ajomatka',
  view_voucher: 'Näytä voucher',
  view_more_bookings: 'Näytä lisää varauksia',
  identity_verification_body: 'Sinua pyydetään vahvistamaan henkilöllisyytesi ennen ajoneuvon noutoa',
  identity_verification_title: 'Vahvista henkilöllisyys',
  search_again: 'Hae uudelleen',
  not_available: 'Drive &amp; Go on tällä hetkellä saatavilla vain asiakkaille, joiden henkilöllisyys- ja ajokortin alkuperäinen maa on {profiles}, mutta lisäämme jatkuvasti uusia maita.',
  check_if_included: 'Tarkista, onko maasi mukana.',
  included_in_booking: 'Sisältyy tähän varaukseen',
  cdw_with_excess: 'Kolariturva omavastuulla',
  theft_protection: 'Varkausturva omavastuulla',
  risk_reduction: 'Riskien vähentäminen',
  free_extras: 'Saat kaksi ilmaista ekstra tuotetta <br /> tällävarauksella.',
  total_cost: 'Vuokrauksen kokonaishinta',
  continue: 'Jatka',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'S',
  luggage_large_long_label: 'suuri',
  luggage_medium_long_label: 'keskikokoinen',
  luggage_small_long_label: 'pieni',
  fuel_unspecified_label: 'määrittämätön',
  transmission_manual_label: 'Manuaali',
  transmission_automatic_label: 'Automaatti',
  make_a_booking: 'Tee varaus',
  pickup_date: 'Noutopäivä',
  dropoff_date: 'Palautuspäivä',
  driver_age: 'Kuljettajan ikä 30–65',
  enter_driver_age: 'Kuljettajan ikä',
  promo_code: 'Alennuskoodi',
  search: 'Hae',
  dropoff_date_cannot_be_before_pickup_date: 'Palautuspäivä ei voi olla ennen noutopäivää',
  pickup_date_cannot_be_in_the_past: 'Noutopäivä ei voi olla menneisyydessä',
  pickup_time_cannot_be_in_the_past: 'Noutoaika ei voi olla menneisyydessä',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Palautusajan on oltava noutoaikaa myöhemmin, jos palautus on samalle päivälle',
  vehicle_filters: 'Hakukriteerit',
  reset: 'Nollaa',
  transmission: 'Vaihteisto',
  all: 'Kaikki',
  manual: 'Manuaali',
  auto: 'Automaatti',
  passengers: 'Matkustajat',
  vehicle_type: 'Ajoneuvotyyppi',
  filter: 'Hakuvaihtoehdot',
  vehicle_search: 'Ajoneuvohaku',
  edit: 'Muokkaa',
  no_results: 'Ei yhtään tulosta valituilla hakukriteereillä.',
  small_cars: 'Pienet autot',
  medium_cars: 'Keskikokoiset autot',
  large_cars: 'Suuret autot',
  estate_cars: 'Farmariautot',
  suvs: 'Katumaasturit',
  mpvs: 'Tila-autot',
  vans: 'Pakettiautot',
  camper_vans: 'Matkailuautot',
  premium: 'Premium',
  unspecified: 'määrittämätön',
  large: 'suuri',
  medium: 'keskikokoinen',
  small: 'pieni',
  automatic: 'automaatti',
  you_have_been_refunded: 'Maksusi on palautettu.',
  please_customer_service: 'Jos haluat tehdä varauksen, ota yhteyttä asiakaspalveluumme.',
  contact_customer_service: 'Ota yhteyttä asiakastukeen',
  booking_failed: 'Varaustasi ei voitu käsitellä juuri nyt.',
  summary: 'Yhteenveto',
  reforestation_and_protection: 'Tue uudelleen metsitystä ja suojele sademetsiä Costa Ricassa',
  cost_of_rental: 'Vuokrauksen hinta',
  to_pay_now: 'Maksetaan nyt',
  pay_on_arrival: 'Maksetaan saapuessa',
  greenheart_donation: 'Green Heart -lahjoitus',
  tc_agreement: 'Olen lukenut ja ymmärtänyt {0}.',
  tc: 'Käyttöehdot',
  receive_offers: 'Haluan vastaanottaa erikoistarjouksia sähköpostitse.',
  donate: 'Kyllä haluan lahjoittaa {amount}',
  pay_now: 'Maksa {amount} nyt',
  driver_details: 'Kuljettajan tiedot',
  complete_driver_details: 'Kirjoita kaikki kuljettajan tiedot.',
  are_you_the_driver: 'Oletko kuljettaja?',
  have_an_account: 'Onko sinulla jo tili?',
  login: 'Kirjaudu',
  or: 'tai',
  first_name: 'Kuljettajan etunimi',
  last_name: 'Kuljettajan sukunimi',
  email: 'Sähköpostiosoite',
  phone_number: 'Matkapuhelinnumero',
  unable_to_save_driver_information: 'Ei voi tallentaa kuljettajan tietoja. Yritä uudelleen.',
  pay_online_now: 'Maksa nyt',
  day: 'Päivä',
  choose_location: 'Valitse sijainti',
  location_not_found: 'Ikävä kyllä emme löytäneet hakemaasi paikkaa',
  add: 'Lisää',
  remove: 'Poista',
  free_extra: 'Ilmainen ekstra',
  free: 'VELOITUKSETTA!',
  fast_track_notice: 'Asiakirjan alkuperrärajoitukset pätevät tähän palveluun. Se on saatavilla vain asiakkaille, joiden asiakirjojen alkuperä on',
  complete_booking: 'Suorita varaus loppuun',
  choose_card: 'Valitse kortti tai lisää uusi.',
  add_billing_details: 'Lisää laskutustiedot.',
  card_number: 'Korttinumero',
  card_holder_name: 'Kortinhaltijan nimi',
  card_exp: 'KK/VV',
  card_cvc: 'CVC',
  save_card: 'Tallennetaanko kortti?',
  amount_charged: 'Korttiasi veloitetaan',
  payment_confirmation: 'Vahvista varaus ja maksu',
  payment_methods: 'käytettävissä olevat maksutavat',
  use_saved_card: 'x käytä tallennettua korttia',
  use_different_card: '+ käytä eri korttia',
  book_now: 'Varaa nyt',
  minimum_age: 'Yli {age} vuotiaille',
  excess_liability: 'Omavastuu',
  security_deposit: 'Katevarmenne',
  fuel_policy: 'Polttoainekäytäntö',
  like_for_like: 'Vastaava',
  full_to_full: 'Täysi / Täysi',
  miles_per_rental: '{mileage} Kilometriä per vuokraus',
  km_per_rental: '{mileage} Ilmaista kilometriä per vuokraus',
  unlimited: 'Rajoittamaton',
  unlimited_mileage: 'Rajattomat kilometrit',
  unlimited_mileage_km: 'Rajattomat kilometrit',
  non_amendable: 'Ei muutettavissa / muokattavissa',
  non_refundable: 'Ei peruutettavissa',
  free_cancellation_until: 'Ilmainen peruutus päättyy:',
  cancellation_in_line_with: 'Peruutuksen peruste:',
  tcs: 'Käyttöehdot',
  free_extras_on_collection: 'Kaksi ilmaista ekstraa noudattaessa',
  glass_and_tyres_covered: 'Tuulilasi ja renkaat katetaan',
  number_of_passengers: 'Matkustajien lukumäärä',
  number_of_bags: 'Laukkujen lukumäärä',
  fuel_type: 'Polttoainetyyppi',
  co2: 'CO2',
  aircon: 'Ilmastointi',
  refrigeration: 'jäähdytetty',
  book_type: 'Varaa {type}',
  processing: 'Käsitellään',
  actual_price: 'Todellinen hinta',
  tooltip: 'Hinta valuutassa ${currencyCode} on arvio, joka perustuu vaihtokurssiin. Hinta valuutassa ${currency} on sitova.',
  pay_online: 'Maksa nyt verkossa',
  pay_online_without_extras: 'Vuokrahinta ilman lisävarusteita',
  extras_on_arrival: 'Lisävarusteet saapuessa',
  insurance_on_arrival: 'maksa saapuessa',
  insurance_online: 'Maksa - maksa nyt',
  extras_online: 'Maksa lisävarusteet nyt',
  green_heart_donation: 'Green Heart -lahjoitus',
  aircon_lower: 'ilmastointi',
  why_use_drive_and_go: 'Miksi Drive & Go -palvelua kannattaa käyttää',
  straight_to_car: 'Suoraan autoon',
  no_queues: 'Ei jonoja',
  self_checkout: 'Auton nouto itsepalveluna',
  cant_lose_key: 'Avainta ei voi hukata.',
  online_id_check: 'Henkiöllisyyden tarkastus verkkopalvelussa',
  phone_as_key: 'Puhelin toimii avaimena.',
  premiumplus_benefits_includes: 'Sisältää Premium Plus+ -edut',
  book_drive_go: 'Tee Drive & Go -varaus',
  duration: 'Kesto',
  to_pay_on_arrival: 'Maksetaan saapuessa',
  return_date: 'Paluupäivä',
  postcode: 'Postinumero',
  country: 'Maa',
  my_profile: 'Profiilini',
  drive_and_go: {
    drive_and_go: 'Drive And Go',
    available_countries: 'Drive &amp; Go on tällä hetkellä saatavilla vain ihmisille, joiden henkilöllisyys- ja ajokortin alkuperä on jokin seuraavista maista:',
    drive_and_go_today: 'Tee Drive & Go -varaus tänään!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Miksi Drive & Go -palvelua kannattaa käyttää?',
    straight_to_car: 'Suoraan autoon',
    no_queues: 'Ei jonoja',
    self_checkout: 'Nouto itsepalveluna',
    cannot_lose_the_key: 'Avainta ei voi hukata.',
    online_id_check: 'Henkilöllisyyden tarkastus verkkopalvelussa',
    phone_as_a_key: 'Puhelin toimii avaimena.',
    premium_plus_benefits_also_included: 'Sisältää Premium Plus+ -edut',
    book_drive_and_go: 'Tee Drive & Go -varaus'
  },
  my_bookings: 'Omat varaukset',
  no_bookings: 'Ei varauksia',
  no_bookings_to_display: 'Ei näytettäviä varausta.',
  search_great_car_rental_deals: "Hae mahtavia tarjouksia seuraavaa matkaasi varten",
  odometer_at_collection: 'Matkamittarin lukema noudettaessa',
  fuel_at_collection: 'Polttoaine noudettaessa',
  start_check_in: 'Aloita check-in kirjautuminen',
  start_collection: 'Aloita noutoprosessi',
  recent_bookings: 'Viimeisimmät varaukset',
  damage: {
    updated_damage_report_submitted: 'Päivitetty vahinkoraportti on lähetetty. Asiakastukitiimimme jäsen ottaa tarvittaessa yhteyttä.',
    add_additional_damage: 'Lisää lisävahinkoja.',
    you_may_report_additional_damage_up_to: 'Voit raportoida lisävahinkoja 24 tunnin ajan ajoneuvon noutohetkestä',
    specify_damage: 'Määrittele vahinko',
    please_choose_the_area_and_type_of_damage: 'Valitse vaurioalue ja vaurion tyyppi',
    type_of_damage: 'Vaurion tyyppi',
    is_this_more_than_5_cm: 'Onko vaurion koko yli 5 cm?',
    please_take_or_select_a_photo: 'Ota tai valitse valokuva',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Ota valokuva, jossa vaurio näkyy selkeästi.',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: 'Voit lisätä tarvittaessa toisen valokuvan valitsemalla lisää kuva.',
    save_image: 'Tallenna kuva',
    save_images: 'Tallenna kuvat',
    damage_saved_successfully: 'Vaurio tallennettu',
    add_photo: 'Lisää valokuva'
  },
  checkout: {
    start_collection: 'Aloita nouto',
    collect_vehicle: 'Nouda ajoneuvo',
    we_will_let_you_know_the_details: 'Kerromme toimipaikan ja tiedot, joiden avulla löydät vuokra-ajoneuvon',
    inspect: 'Tarkasta',
    we_will_ask_for_four_photos_from_each_corner: 'Pyydämme neljä valokuvaa, yhden ajoneuvon kultakin kulmalta, sekä mahdolliset uudet vauriot, joita ei ole jo lueteltu.',
    fuel_and_milage: 'Polttoaine ja ajokilometrit',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Vahvistat matka- ja polttoainemittarin lukeman vuokrauksen alussa.',
    sign: 'Allekirjoita',
    sign_the_rental_agreement: 'Allekirjoita vuokrasopimus.',
    away_you_go: 'Lähde ajamaan',
    you_are_free_to_take_to_the_road: 'Voit lähteä tien päälle!',
    collect_your_vehicle: 'Nouda ajoneuvo',
    get_directions: 'Hae nouto-ohjeet',
    hide_directions: 'Piilota nouto-ohjeet',
    local_time: 'paikallinen aika',
    tel: 'Puh.',
    getting_to_the_location: 'Sijaintiin pääseminen',
    get_vehicle_details: 'Hae ajoneuvon tiedot',
    view_map: 'Näytä kartta',
    unlock_vehicle_and_continue: 'Avaa ajoneuvon lukitus ja jatka',
    unable_to_connect_to_vehicle: 'Ajoneuvoon ei saada yhteyttä',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Emme saaneet ajoneuvoon yhteyttä. Tarkista, että olet oikean ajoneuvon vieressä, ja yritä uudelleen.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Emme löytäneet ajoneuvon varausta. Yritä myöhemmin uudelleen.',
    odometer_and_fuel: 'Matkamittari ja polttoaine',
    odometer: 'Matkamittari',
    please_confirm_the_odometer_and_fuel_readings: 'Varmista mahdollisuuksien mukaan matkamittarin ja polttoaineen lukemat',
    the_odometer_field_is_required: 'Matkamittari-lukema on pakollinen tieto',
    and_must_be_greater_than_the_checkout_odometer: 'ja arvon on oltava suurempi kuin matkamittarilukema noudettaessa.',
    confirm: 'Vahvista',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Ota valokuva, yksi ajoneuvon kultakin kulmalta.',
    pre_existing_damage: 'Olemassa olevat vauriot',
    no_pre_existing_damage: 'Ei aiemmin syntyneitä vaurioita',
    new_damage: 'Uudet vauriot',
    add_additional_damage: 'Lisää uusi vaurio',
    no_new_damage_to_report: 'Ei uusia ilmoitettavia vaurioita',
    checkout_complete: 'Noutoprosessi valmis',
    start_rental: 'Aloita vuokraus',
    congratulations_name_it_is_time_to_take_to_the_road: 'Onnittelut, {customer_name} aika lähteä tien päällle!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Emme saaneet vahvistettua check-outtia',
    please_do_the_following: 'Toimi seuraavasti',
    remove_all_belonging_and_lock_the_vehicle: 'Kerää kaikki tavarasi ja lukitse auto.',
    lock_vehicle: 'Lukitse auto',
    once_you_have_contacted_customer_services: 'Kun olet ottanut yhteyttä asiakastukeen',
    vehicle_location: 'Auton sijainti',
    collect_your: 'Nouda',
    from: 'Kohteesta',
    key_in_glove_box: 'Avaimesi sijaitsee hansikaslokerossa',

    keyholder: {
      not_detected: 'Avainta ei havaittu',
      not_detected_please_try_again: 'Aseta avain avaimenpitimeen ja yritä uudelleen.',

      not_installed: 'Avainta ei ole asennettu',
      not_installed_please_contact_customer_service: 'Avainta ei ole asennettu, ota yhteyttä asiakaspalveluun.',
    },
    keyring: {
      look_up_failed: 'Avaimen haku epäonnistui',
      look_up_failed_please_contact_customer_service: 'Avaimenperän haku epäonnistui, ota yhteyttä asiakaspalveluun.',
    },
    key: {
      invalid: 'Avain on virheellinen',
      invalid_please_contact_customer_service: 'Avaimesi on virheellinen, ota yhteyttä asiakaspalveluun.',

      expired: 'Avain on vanhentunut',
      expired__please_contact_customer_service: 'Avaimesi on vanhentunut, ota yhteyttä asiakaspalveluun.',
    }
  },
  checkin: {
    start_check_in: 'Aloita sisäännkirjautuminen',
    vehicle_location: 'Ajoneuvon sijainti',
    tell_us_where_you_have_parked: 'Kerro, mihin pysäköit auton.',
    fuel_and_milage: 'Polttoaine ja ajokilometrit',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Vahvistat matka- ja polttoainemittarin lukeman vuokrauksen lopussa.',
    inspect: 'Tarkasta',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Pyydämme neljä valokuvaa, yhden ajoneuvon kultakin kulmalta, sekä vuokrauksen aikana mahdollisesti tulleet uudet vauriot.',
    lock: 'Lukittu',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Tarkista, ettei autoon ole jäänyt tavaroita, ja lukitse auto',
    please_tell_us_where_you_have_parked_the_vehicle: 'Kerro, mihin pysäköit auton.',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Kun auto on lukittu, et voi avata sitä uudelleen.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, tarkista, että et ole jättänyt tavaroita autoon, lukitse ajoneuvo ja palauta tarvittaessa fyysinen avain avaimen haltijalle.',
    lock_vehicle: 'Lukitse auto',
    complete_check_in: 'Tee check-in',
    inspection: 'Tarkastus',
    complete_vehicle_check_in: 'Tee auton palautus valmiiksi',
    we_are_unable_to_complete_your_vehicle_check_in: 'Emme pysty tekemään auton palautusta valmiiksi.',
    please_contact_customer_services: 'Ota yhteyttä asiakastukeen.',
    once_you_have_contacted_customer_services: 'Kun olet ottanut yhteyttä asiakastukeen',
    please_amend_odometer_to_be_greater_than: 'Muuta matkamittari suuremmaksi kuin {odometer_value}',
  },
  rental_agreement: {
    rental_agreement: 'Vuokrasopimus',
    agreement_between: 'Seuraavien osapuolten välinen sopimus:',
    and: 'ja',
    sign_rental_agreement: 'Allekirjoita vuokrasopimus.',
    i_have_read_and_understood_the_terms_and_conditions: 'Olen lukenut ja ymmärtänyt käyttöehdot ja hyväksynyt ajoneuvon kunnon'
  },
  additional_options: 'Lisävaihtoehdot',
  booking_details: "Varaustiedot",
  price_for_x_days: '{qty_of_days} Kokonaishinta| Hinta {qty_of_days} vuorokaudet',
  cancelled: 'Peruutettu',
  upcoming: 'Tuleva',
  active: 'Aktiivinen',
  full_insurance_no_deposit: 'Täysi vakuutus eikä katevarmennetta vaadita',
  excess: '{amount} Katevarmenne',
  deposit: '{amount} Katevarmenne',
  included_daily_distance: '{distance} {unit} Vuorokausi',
  miles: 'mailia',
  kilometers: 'kilometriä',
  collection_details_title: 'Nouto-ohjeet',
  collection_details_not_found: 'Tälle sijainnille ei ole määrritetty nouto-ohjeita',
  free_cancellation: 'Ilmainen peruutus',
  no_deposit: 'No Deposit',
  benefit_from: 'Hyötyvät',
  for_only_per_day: 'Vain {price} päivässä',
  upgrade_mee: 'UpgradeMee'
}




// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/fi/bookings.js